import { lazyNamed } from 'src/utils/lazyNamed';

export const ConsultingProducts = {
  Helmet: lazyNamed(() => import('./components/Helmet'), 'Helmet'),
  Layout: lazyNamed(() => import('./components/Layout'), 'Layout'),
  ProductsList: lazyNamed(() => import('./containers/ProductsList'), 'ProductsList'),
  ProductForm: lazyNamed(() => import('./containers/ProductForm'), 'ProductForm'),
  AdMediaList: lazyNamed(() => import('./containers/AdMediaList'), 'AdMediaList'),
  AdMediaHistory: lazyNamed(() => import('./containers/AdMediaHistory'), 'AdMediaHistory'),
  PlacementsList: lazyNamed(() => import('./containers/PlacementsList'), 'PlacementsList'),
  PlacementHistory: lazyNamed(() => import('./containers/PlacementHistory'), 'PlacementHistory'),
  AdTypesList: lazyNamed(() => import('./containers/AdTypesList'), 'AdTypesList'),
  AdTypeHistory: lazyNamed(() => import('./containers/AdTypeHistory'), 'AdTypeHistory'),
  AdPricesList: lazyNamed(() => import('./containers/AdPricesList'), 'AdPricesList'),
  AdPriceForm: lazyNamed(() => import('./containers/AdPriceForm'), 'AdPriceForm'),
  AdPriceHistory: lazyNamed(() => import('./containers/AdPriceHistory'), 'AdPriceHistory'),
  ProductHistory: lazyNamed(() => import('./containers/ProductHistory'), 'ProductHistory'),
};
